var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSirenWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 83,
    height: 78,
    viewBox: "0 0 83 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M68.4326 57.8405H14.5676L18.5773 24.3199C18.8829 21.7645 19.0358 20.4868 19.2926 19.3954C21.2281 11.1681 28.1266 5.04564 36.5255 4.10092C37.6398 3.97559 38.9265 3.97559 41.5001 3.97559V3.97559C44.0737 3.97559 45.3604 3.97559 46.4747 4.10092C54.8736 5.04564 61.772 11.1681 63.7076 19.3954C63.9644 20.4868 64.1172 21.7645 64.4229 24.3199L68.4326 57.8405Z",
    stroke: "white",
    strokeOpacity: 0.4,
    strokeWidth: 6.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M71.2058 57.8405H11.7949C8.99466 57.8405 7.59453 57.8405 6.52497 58.3855C5.58416 58.8648 4.81926 59.6297 4.33989 60.5705C3.79492 61.6401 3.79492 63.0668 3.79492 65.9202C3.79492 68.7736 3.79492 70.2004 4.33989 71.2699C4.81926 72.2107 5.58416 72.9756 6.52497 73.455C7.59453 74 8.99466 74 11.7949 74H71.2058C74.0061 74 75.4062 74 76.4758 73.455C77.4166 72.9756 78.1815 72.2107 78.6609 71.2699C79.2058 70.2004 79.2058 68.7736 79.2058 65.9202C79.2058 63.0668 79.2058 61.6401 78.6609 60.5705C78.1815 59.6297 77.4166 58.8648 76.4758 58.3855C75.4062 57.8405 74.0061 57.8405 71.2058 57.8405Z",
    stroke: "white",
    strokeWidth: 6.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36.113 36.2946C36.113 39.2687 38.5255 41.6811 41.4995 41.6811C44.4736 41.6811 46.886 39.2687 46.886 36.2946C46.886 33.3205 44.4736 30.9081 41.4995 30.9081C38.5255 30.9081 36.113 33.3205 36.113 36.2946Z",
    stroke: "white",
    strokeWidth: 6.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5 41.681L41.5 57.8404",
    stroke: "white",
    strokeWidth: 6.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSirenWhite);
export default __webpack_public_path__ + "static/media/siren-white.ac74726f5299daee7a245001b8dd404b.svg";
export { ForwardRef as ReactComponent };